import React from 'react';
import './showModal.less';
import $ from 'jquery';
let isMoving = false;  //鼠标点击弹窗标题栏 激活可移动操作
let $box = null;
let offsetX = 0;
let offsetY = 0;
let boxOffsetX = 0;
let boxOffsetY = 0;
let isMoveBox=false;  //接收父组件传来值 ，是否起用可移动弹窗操作
class ShowModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isShowDailog: props.showModal,
            isHideCancleBtn: props.isShowCancleBtn ? props.isShowCancleBtn : false,
            sureBtnName: props.sureBtnName ? props.sureBtnName : "确定",
            title: props.titleName ? props.titleName : "确定",
            width: props.width ? props.width : "650px",
            hideBtn: props.hideBtn ? props.hideBtn : false,
            showLeftTopBtn: props.showLeftTopBtn ? props.showLeftTopBtn : false,
            skin: props.skin ? props.skin : "",
            wrapSkin: props.wrapSkin ? props.wrapSkin : "",
            hideTitle: props.hideTitle ? props.hideTitle : false,
            zIndex: props.zIndex ? props.zIndex : 1000,
            showTitleClose: props.showTitleClose ? props.showTitleClose : false,
            isMoveBox: props.isMoveBox?props.isMoveBox:false,
            titleIcon: props.titleIcon,
        };
        this.offsetX = 0;
        this.offsetY = 0;
        this.$box = null;

    }
    componentDidMount() {

            
    }
    componentWillReceiveProps(props) {  //监听父元素 传过来值的变化 触发的函数
        this.setState({
            isShowDailog: props.showModal,
            title: props.titleName ? props.titleName : "确定",
            width: props.width ? props.width : "650px",
        })

    }
    cancel = () => {
        this.setState({
            isShowDailog: false
        }, () => {
            if (typeof this.props.cancelDailog == "function") {
                this.props.cancelDailog();
            }
        })
    }
    sure = () => {
        this.props.sureDailog()
    }
    onMouseBoxUp() {

        isMoving = false;
        window.onmouseup=null;
        window.onmousemove=null;
    }

    onMouseBoxDown(e) {

        window.onmouseup = e => this.onMouseBoxUp(e);
        window.onmousemove = e => this.onMouseBoxMove(e);

        $box = $(e.target).closest(".showModalWrap-box");
        boxOffsetX = $box.offset().left-document.documentElement.scrollLeft;
        boxOffsetY = $box.offset().top-document.documentElement.scrollTop;

        console.log("boxOffsetY",boxOffsetY)


        offsetX = e.clientX;
        offsetY = e.clientY;
        isMoving = true;
        isMoveBox=this.state.isMoveBox;


    }
    onMouseBoxMove(e) {

            

            if (isMoving && isMoveBox) {
                let dx = boxOffsetX - (offsetX - e.clientX);
                let dy = boxOffsetY - (offsetY - e.clientY);
                let innerHeight=window.innerHeight;
                let innerWidth=window.innerWidth;
    
                if (dx <= 0) {
                    dx = 0;
                }
                if (dy <= 0) {
                    dy = 0;
                }
                if(dy>=innerHeight-$box.height()){
                    dy = innerHeight-$box.height();
                }
                if(dx>=innerWidth-$box.width()){
                    dx = innerWidth-$box.width();
                }
    
                if ($box) {
                    $box.css({ left: dx, top: dy });
                }
            }
            
    }

    render() {
        let elems =
            this.state.isShowDailog ?
                <div className={"showModalWrap " + this.state.wrapSkin} style={{ zIndex: this.state.zIndex }}>
                    <div className={"showModalWrap-box " + this.state.skin} style={{ width: this.state.width }}>
                        {
                            !this.state.hideTitle ?
                                <div className="showModalWrap-box-title" style={this.state.isMoveBox?{cursor:'move'}:{}} onMouseDown={e => this.onMouseBoxDown(e)}>
                                    <span>
                                        {
                                            this.state.titleIcon ? this.state.titleIcon:null
                                        }
                                        {this.state.title}
                                    </span>
                                    {
                                        !this.state.hideBtn || this.state.showTitleClose ?
                                            <i className="iconfont icon-jia-copy1" onClick={() => this.cancel()}></i> : this.state.showLeftTopBtn ? <i className="iconfont icon-jia-copy1" onClick={() => this.cancel()}></i> : <i></i>
                                    }
                                </div> : null
                        }
                        <div className="showModalWrap-box-main">
                            {
                                this.props.children ?
                                    this.props.children : this.props.content ? this.props.content : '确认'
                            }
                        </div>
                        {
                            !this.state.hideBtn ?
                                <div className="showModalWrap-box-footer">
                                    <span type="button" class="sureMyBtn" onClick={() => this.sure()}>{this.state.sureBtnName}</span>
                                    {
                                        !this.state.isHideCancleBtn ?
                                            <span type="button" class="cancleMyBtn" onClick={() => this.cancel()}>取消</span> : null
                                    }
                                </div> : null
                        }
                    </div>
                </div> : null
        return (
            elems
        );
    }
}

export default ShowModal;



// WEBPACK FOOTER //
// ./src/components/showModal/index.jsx